/**
 * Convenience class for parsing URLs. Use get, set and extend methods for
 * manipulating GET parameter values.
 * @param {string} url The URL string.
 * @param {Object.<string,string>=} params Query string parameters.
 * @constructor
 * @extends {Foundation.Observable}
 */
Foundation.URL = function (url, params) {
    Foundation.Observable.call(this);

    /**
     * @private
     * @type {string?}
     */
    this.hash = null;

    // Extract the hash from the URL.
    var hashRegex = /#(.*)$/;
    var hashedUrlParts = url.match(hashRegex);
    if (hashedUrlParts) {
        url = url.replace(hashRegex, "");
        if (hashedUrlParts[1] !== "") this.hash = hashedUrlParts[1];
    }

    /**
     * @private
     * @type {string}
     */
    this.url = url;

    var urlComponents = url.match(/^([^?]+)\?(.*)$/);
    if (urlComponents) {
        this.url = urlComponents[1];
        this.extend(Foundation.URL.parseQueryString(urlComponents[2]));
    }

    if (params) this.extend(params);
};
Foundation.inherit(Foundation.URL, Foundation.Observable);

/**
 * Go to this URL.
 */
Foundation.URL.prototype.go = function () {
    this.fire("go");
    window.location = this.toString();
};

/**
 * Convert URL to string.
 * @return {string}
 */
Foundation.URL.prototype.toString = function () {
    var string = this.url;
    if (this.size()) {
        string += `?${Foundation.URL.objectToQueryString(this.plainObject())}`;
    }
    if (this.hash) {
        string += `#${this.hash}`;
    }
    return string;
};

/**
 * Convert URL to string.
 * @return {string}
 */
Foundation.URL.prototype.relativeToString = function () {
  var string = `/${this.pathAsArray().join("/")}`;
    if (this.size()) {
        string += `?${Foundation.URL.objectToQueryString(this.plainObject())}`;
    }
    if (this.hash) {
        string += `#${this.hash}`;
    }
    return string;
};

Foundation.URL.prototype.params = function () {
  return this.plainObject()
}

Foundation.URL.prototype.path = function () {
  return `/${this.pathAsArray().join("/")}`;
}

/**
 * Convenience function for converting a query string into an object.
 * @param {string} str
 * @return {Object.<string,(string|Array.<string>)>}
 */
Foundation.URL.parseQueryString = function (str) {
    var params = {};

    var items = str.replace(/.*\?/, "").replace(/#.*$/, "").split("&");
    for (var i = 0; i < items.length; i++) {
        var pair = items[i].match(/([^=]+)=?(.*)/);
        if (!pair) continue;
        var key = decodeURIComponent(pair[1]);
        var val = decodeURIComponent(pair[2]);

        if (key in params) {
            if (!Array.isArray(params[key])) params[key] = [params[key]];
            params[key].push(val);
        }
        else {
            params[key] = val;
        }
    }

    return params;
};

/**
 * Utility function to serialize an object's properties into a query string.
 * @param {Object.<string,*>} obj
 * @return {string}
 */
Foundation.URL.objectToQueryString = function (obj) {
    var parameters = [];
    for (var key in obj) parameters.push(key);

    // This is how Gyrobase goes about sorting parameters for <evUrl>. Or
    // at least this is something close to it. It hasn't been extensively
    // tested.
    parameters = parameters.sort(function (a, b) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
    });

    /**
     * Encode a query string pair. This is a local helper function because
     * it's recursive.
     * @param {string} name
     * @param {*} value
     */
    function serializeQueryStringPair (name, value) {
        // Loop over array values and return all pairs. This is where we
        // do include empty values in the query string, because we don't
        // want to make arrays shorter.
        if (jQuery.isArray(value)) {
            var pairs = [];
            for (var i = 0; i < value.length; i++) {
                var str = serializeQueryStringPair(name, value[i]);
                if (str === "") str = `${encodeURIComponent(name)}=`;
                pairs.push(str);
            }
            return pairs.join("&");
        }

        // Empty values aren't included in query string, just like <evUrl>.
        if (value === "" || value === null || value === undefined) return "";

        // Encode the name and param, separate with an equals sign.
        return `${encodeURIComponent(name)}=${encodeURIComponent(`${value}`)}`;
    }

    // Apply the above function to all the properties of the passed object.
    var pairs = [];
    for (var i = 0; i < parameters.length; i++) {
        var str = serializeQueryStringPair(parameters[i], obj[parameters[i]]);
        if (str !== "") pairs.push(str);
    }

    return pairs.join("&");
};

/**
 * Set the # hash string of the url.
 * @param {string} hash
 * @return {!Foundation.URL}
 */
Foundation.URL.prototype.setHash = function (hash) {
    this.hash = hash;
    return this;
};

/**
 * Return the URL's hash string.
 * @return {string?}
 */
Foundation.URL.prototype.getHash = function () {
    return this.hash;
};

/**
 * Return the path components of the URL.
 * @return {Array.<string>}
 */
Foundation.URL.prototype.pathAsArray = function () {
    var path = this.url.replace(/^(?:\w+:)?\/\/[^/]+/, "").replace(/\/+/g, "/");
    return path.split(/\//).filter(function (a) { return a !== ""; });
};

/**
 * @return {!Foundation.URL}
 */
Foundation.URL.fromCurrentLocation = function () {
    return new Foundation.URL(window.location.href);
};

// ---------------------------------------------------------------------

export default Foundation.URL

window["Foundation"]["URL"] = Foundation.URL;
window["Foundation"]["URL"].prototype["go"] = Foundation.URL.prototype.go;
window["Foundation"]["URL"].prototype["toString"] = Foundation.URL.prototype.toString;

window["Foundation"]["URL"]["parseQueryString"] = Foundation.URL.parseQueryString;
window["Foundation"]["URL"]["objectToQueryString"] = Foundation.URL.objectToQueryString;
